import axios from 'axios';
import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import { LoadingStatus } from '../../constants';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'unassignedTable',
  url: '/api/sequenceIntervals/unassigned',
});

/**
 * It might be a bit un-intuitive to find the "assigned rows" function in the
 * "unassigned" reducers. The reason is that the reducer covers functionality to
 * assign new tasks to labelers. Sometimes, we want to assign a task twice to
 * check for inter-labeler variability. */
export const fetchRowsAssigned = createAsyncThunk(
  'unassigned/fetchRowsAssigned',
  async (notLabellerId, { getState }) => {
    const {
      unassigned: {
        table: { limit, page, sort },
      },
    } = getState();

    const response = await axios.get('/api/sequenceIntervals/assigned', {
      params: {
        limit,
        page,
        sort,
        not_labeller_id: notLabellerId,
      },
    });
    return response.data;
  }
);

export const fetchLabellers = createAsyncThunk('unassigned/fetchLabellers', async () => {
  const response = await axios.get('/api/users');
  return response.data;
});

const initialState = {
  status: LoadingStatus.IDLE,
  actionBar: {
    status: LoadingStatus.PENDING,
    selectedLabeller: null,
    labellersById: {},
    labellersByNameLookup: {},
    shouldFetchAssigned: false,
  },
};

const unassignedSlice = createSlice({
  name: 'unassigned',
  initialState,
  reducers: {
    setSelectedLabeller(state, action) {
      state.actionBar.selectedLabeller = action.payload;
    },
    unsetSelectedLabeller(state) {
      state.actionBar.selectedLabeller = null;
    },
    removeItemsById(state, action) {
      state.rows = state.rows.filter((item) => !action.payload.includes(item.id));
    },
    setShouldFetchAssigned(state, action) {
      state.actionBar.shouldFetchAssigned = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabellers.pending, (state) => {
        state.labellersByNameStatus = LoadingStatus.PENDING;
      })
      .addCase(fetchLabellers.fulfilled, (state, action) => {
        action.payload.users.forEach((user) => {
          const userObject = {
            id: user.id,
            name: user.name,
            email: user.email,
          };
          state.actionBar.labellersById[user.id] = userObject;
          state.actionBar.labellersByNameLookup[user.name] = user.id;
        });
        state.actionBar.status = LoadingStatus.DONE;
      });
  },
});

export const selectSelectedLabeller = ({ unassigned }) => unassigned.actionBar.selectedLabeller;
export const selectLabellersByName = ({ unassigned }) =>
  Object.keys(unassigned.actionBar.labellersByNameLookup);

export const selectLabellersById = ({ unassigned }) => unassigned.actionBar.labellersById;
export const selectLabellerIdByName = createSelector(
  (state) => state.unassigned.actionBar.labellersByNameLookup,
  (_, name) => name,
  (labellersByNameLookup, name) => (name ? labellersByNameLookup[name] : '')
);
export const selectAssignmentButtonReady = createSelector(
  tableSlice.selectors.selectSelectedRows,
  selectSelectedLabeller,
  (selectedRows, selectedLabeller) => selectedRows.length > 0 && selectedLabeller
);
export const selectActionBarStatus = ({ unassigned }) => unassigned.actionBar.status;
export const selectActionBar = ({ unassigned }) => unassigned.actionBar;

export const selectUnassignedState = (state) => state.unassigned;

export const {
  // updateTableState,
  // setSelectedRow,
  // clearSelectedRows,
  setSelectedLabeller,
  unsetSelectedLabeller,
  // removeItemsById,
  // setShouldFetchAssigned,
  // updateFilter,
} = unassignedSlice.actions;
export default unassignedSlice.reducer;
